<script setup lang="ts">
import { useUserInfoStore } from '@/stores/modules/user'

const userStore = useUserInfoStore()
</script>
<template>
  <div class="logo">
    <img src="/favicon.ico" alt="鼎骁科技" style="width: 32px; height: 32px;" />
    <span v-if="!userStore.collapse" class="font-bold text-black text-nowrap">鼎骁科技</span>
  </div>
</template>
<style scoped lang="scss">
.logo {
  @apply flex justify-center items-center space-x-4 py-4;
}
</style>
